import { render, staticRenderFns } from "./modalDeleteParticipant.vue?vue&type=template&id=67e81346&"
import script from "./modalDeleteParticipant.vue?vue&type=script&lang=js&"
export * from "./modalDeleteParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports